exports.aiLabelsOptions = [
    'arts_culture',
    'business_entrepreneurs',
    'celebrity_pop_culture',
    'diaries_daily_life',
    'family',
    'fashion_style',
    'film_tv_video',
    'fitness_health',
    'food_dining',
    'gaming',
    'learning_educational',
    'music',
    'news_social_concern',
    'other_hobbies',
    'relationships',
    'science_technology',
    'sports',
    'travel_adventure',
    'youth_student_life',
    'positive',
    'neutral',
    'negative',
    'anger',
    'anticipation',
    'disgust',
    'fear',
    'joy',
    'love',
    'optimism',
    'pessimism',
    'sadness',
    'surprise',
    'trust',
    'llm_generated',
    'spam',   
    'sexual', 
    'hate',
    'violence',
    'harassment',
    'selfharm',
    'sexual_minors',
    'hate_threatening',
    'violence_graphic',
    'web3_nft',
    'web3_defi',
    'web3_infra',
    'web3_industry',
    'web3_consumer',
    'is_informative',
    'is_educative',
    'is_creative',
    'is_inspiring',
    'is_funny',
    'is_prediction',
    'market_sentiment_bullish',
    'market_sentiment_bearish',
];

exports.tbaAiLabelCategoriesOptions = [
    "ai_developer",
    "animals",
    "art_design",
    "beauty_style",
    "comedy",
    "creator_economy",
    "crypto",
    "educational",
    "entertainment",
    "entrepreneurship",
    "fitness_health",
    "food_drink",
    "gaming",
    "lifestyle",
    "love_family",
    "memes",
    "music_dance",
    "nature",
    "news",
    "politics",
    "religion",
    "science_technology",
    "sports",
    "travel",
]

exports.tbaAiLabelTopicsOptions = [
    "breaking_stories",
    "breakthroughs",
    "business_news",
    "chains",
    "coins",
    "collectible_sounds",
    "creative_design",
    "cultural_exploration",
    "cultural_jokes",
    "cultural_takes",
    "cute_pets",
    "daily_routines",
    "day_in_life_abroad",
    "digital_art",
    "digital_fashion",
    "ecosystems",
    "education",
    "educational",
    "ethical_debates",
    "fan_discussions",
    "food_hacks",
    "funny_animals",
    "gaming_clips",
    "generative_visuals",
    "health",
    "highlight_clips",
    "illustration",
    "industry_news",
    "makeup_tutorials",
    "new_places",
    "niche_cuisines",
    "nutrition",
    "onchain_drops",
    "original_songs",
    "other",
    "personal_aesthetic",
    "plating",
    "player_interviews",
    "political_news",
    "political_opinions",
    "productivity",
    "recipes",
    "recovery",
    "remixes",
    "reviews",
    "soft_life",
    "streaming_trends",
    "style_tips",
    "tech_industry",
    "tools",
    "tutorials",
    "use_cases",
    "viral_humor",
    "vlogs",
    "wildlife",
    "workout_clips_tips"
]

exports.embedDomainsOptions = [
    // nft
    "zora.co", 
    "moshi.cam",
    "wallet.coinbase.com",
    "superrare.com", 
    "rarible.com",  
    "manifold.xyz",
    "highlight.xyz",
    "mint.fun", 
    "opensea.io",
    "sorare.com",
    "magiceden.io",
    "blur.io",
    "looksrare.org",
    "niftygateway.com",
    "pods.media",
    // articles
    "paragraph.xyz", 
    "mirror.xyz", 
    "t2.world",
    "medium.com",
    "coindesk.com",
    "decrypt.co",
    "theblock.co",
    "bitcoinmagazine.com",
    "blockworks.co",
    "thedefiant.io",
    "cryptonews.com",
    "coinTelegraph.com",
    // video
    "drakula.app", 
    "stream.warpcast.com", 
    "streamm.tv",
    "video.twimg.com",
    "stream.takoassets.so",
    "video.twimg.com",
    // images
    "i.imgur.com", 
    "imagedelivery.net",
    "images.farcaster.phaver.com",
    "ik.imagekit.io",
    "vz-629bcc17-285.b-cdn.net",
    //polls
    "frames.weponder.io", 
    // subscriptions
    "hypersub.withfabric.xyz" , 
    // events
    "events.xyz", 
    // bounties
    "bountycaster.xyz", 
    // projects
    "launchcaster.xyz",
    "dexscreener.com", 
    "clank.fun",
    "clanker.world",
    "pump.fun"
];


exports.endpointOptions = [
    'casts/feed/for-you',
    // 'casts/feed/reranked', 
    // 'casts/feed/similar',
    'casts/feed/trending',
    'casts/feed/popular'
    // 'casts/search/semantic'
]

exports.videoOrientationOptions = [
    {label: 'wide (19/6)', value: 'wide'},
    {label: 'classic (4/3)', value: 'classic'},
    {label: 'square (1/1)', value: 'square'},
    {label: 'vertical (9/16)', value: 'vertical'},
    {label: 'tall (3/4)', value: 'tall'},
    {label: 'portrait (4/5)', value: 'portrait'}
]

exports.videoLanguageOptions = [
    {label: 'Arabic (ar)', value: 'ar'},
    {label: 'Bengali (bn)', value: 'bn'},
    {label: 'German (de)', value: 'de'},
    {label: 'English (en)', value: 'en'},
    {label: 'Spanish (es)', value: 'es'},
    {label: 'Persian (fa)', value: 'fa'},
    {label: 'Irish (ga)', value: 'ga'},
    {label: 'Hebrew (he)', value: 'he'},
    {label: 'Hindi (hi)', value: 'hi'},
    {label: 'Indonesian (id)', value: 'id'},
    {label: 'Italian (it)', value: 'it'},
    {label: 'Japanese (ja)', value: 'ja'},
    {label: 'Multiple languages (mul)', value: 'mul'},
    {label: 'Portuguese (pt)', value: 'pt'},
    {label: 'Enawené-Nawé (unk)', value: 'unk'},
    {label: 'Yoruba (yor)', value: 'yor'},
    {label: 'Chinese (zh)', value: 'zh'},
    {label: 'No linguistic content (zxx)', value: 'zxx'},
]

exports.miniappCategoriesOptions = [
    {label: 'games', value: 'games'},
    {label: 'social', value: 'social'},
    {label: 'finance', value: 'finance'},
    {label: 'utility', value: 'utility'},
    {label: 'productivity', value: 'productivity'},
    {label: 'health-fitness', value: 'health-fitness'},
    {label: 'news-media', value: 'news-media'},
    {label: 'music', value: 'music'},
    {label: 'shopping', value: 'shopping'},
    {label: 'education', value: 'education'},
    {label: 'developer-tools', value: 'developer-tools'},
    {label: 'entertainment', value: 'entertainment'},
    {label: 'art-creativity', value: 'art-creativity'}
]
// exports.scoringOptions = {
//     "casts/feed/trending": ['30min', '1hour', '3hours', '1day', '3days'],
//     "casts/feed/popular": ['30min', '1hour', '3hours', '1day', '3days'],
//     "casts/feed/for-you": ['like', 'recast', 'reply', 'all'],
//     "casts/feed/reranked": ['all'],
//     "casts/feed/similar": [],
//     "casts/search/semantic": []
//   };
exports.scoringOptions = [
    'balanced_feed_v0.0.1', // first entry is used as default
    'balanced_feed_interest_bias_v0.0.1',
    'balanced_feed_affinity_bias_v0.0.1',
    'user_affinity_all_following_v0.0.1',
    'user_affinity_closest_following_v0.0.1',
    'user_interest_all_v0.0.1',
    'user_interest_recent_v0.0.1',
    'trending_v0.0.1',
    'popular_v0.0.1',
]

exports.hideScoringOptions = ['casts/search/semantic', 'casts/feed/similar'];

exports.computeUnitsPerApiCall = {
    'casts-feed-trending': 15,
    'casts-feed-popular': 15,
    'casts-feed-for-you': 100,
    'casts-feed-reranked': 100,
    'casts-feed-similar': 100,
    'casts-semantic-search': 50,
    'casts-labels-for-items': 25,
    'casts-labels-for-text': 25,
    'casts-labels-top-items': 25,
    'users-feed-similar': 50,
    'users-semantic-search': 50,
    'users-labels-for-users': 50,
    'users-labels-top-users': 50
}

exports.mbdUsagePlans = {
    "free": {
        "cuQuota": 1000000,
        "feedQuota": 1
    },
    "price_1PxWhPBLZFYgMsTFMV2pgwOR" : {
        "cuQuota": 1000000,
        "feedQuota": 1
    },
    "price_1PxWhPBLZFYgMsTFaEeDvFxV" : {
        "cuQuota": 1000000,
        "feedQuota": 1
    },
    "price_1PxWiOBLZFYgMsTFQg1V3eLo": {
        "cuQuota": 50000000,
        "feedQuota": 2
    },
    "price_1PxWiOBLZFYgMsTFwxOdgxIv": {
        "cuQuota": 50000000,
        "feedQuota": 2
    },
    "price_1PxWjZBLZFYgMsTFchhDPM1u": {
        "cuQuota": 100000000,
        "feedQuota": 20
    },
    "price_1PxWjZBLZFYgMsTF5HRxrKYr": {
        "cuQuota": 100000000,
        "feedQuota": 20
    },
    "Enterprise": { 
        "cuQuota": null,
        "feedQuota": null
    },
    "enterprise_coinbase":{
        "cuQuota": 400000000,
        "feedQuota": 10000
    },
    "mbd_internal":{
        "cuQuota": 400000000,
        "feedQuota": 10000
    },
    // test mode plans
    "price_1Q7VD5BLZFYgMsTFWsNLvP37" : {
        "cuQuota": 1000000,
        "feedQuota": 1
    },
    "price_1Q7VFABLZFYgMsTFCKyFCqhV" : {
        "cuQuota": 1000000,
        "feedQuota": 1
    },
    "price_1Q7VG0BLZFYgMsTFUqUKf5ub": {
        "cuQuota": 50000000,
        "feedQuota": 2
    },
    "price_1Q7VGQBLZFYgMsTF5ZvMLQNy": {
        "cuQuota": 50000000,
        "feedQuota": 2
    },
    "price_1Q7VH1BLZFYgMsTFiVbatkbB": {
        "cuQuota": 100000000,
        "feedQuota": 20
    },
    "price_1Q7VHTBLZFYgMsTFqbDEtoEr": {
        "cuQuota": 100000000,
        "feedQuota": 20
    },
}

exports.publicationTypesOptions = [
    'image',
    'video',
    'audio',
    'miniapp',
    'zora_image',
    'zora_video',
    // 'web3_nft',
    // 'music',
    // 'article',
    // 'poll',
    // 'subscription',
    // 'event',
    // 'bounty',
    // 'project',
    // 'social',
    // 'crypto_other',
    // 'quest',
    // 'messaging',
    // 'code'
]

exports.appFidOptions = [
    "9152", // Warpcast
    "309857", // Coinbase Wallet
    "6131", // Neynar
    "403507", // $DEGEN Tip Bot
    "193137", // Super
    "807370", // The Masks Bot
    "16823", // Firefly
    "188926" // Privy
]